import script from "./mesCommandesView.vue?vue&type=script&setup=true&lang=js"
export * from "./mesCommandesView.vue?vue&type=script&setup=true&lang=js"

import "./mesCommandesView.vue?vue&type=style&index=0&id=f0cf8016&lang=scss&scoped=true"
import "./mesCommandesView.vue?vue&type=style&index=1&id=f0cf8016&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0cf8016"]])

export default __exports__